
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent } from '@ionic/vue';
import BadgeList from '@/components/Badge/BadgeList.vue';

export default  {
  name: 'ReadTab',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage, BadgeList}
}
